<div  [ngClass]="[bntStyle]" (click)="onChangeBaseMapSatellite()">
</div>
